import {
  BUNDLE_SECTIONS_SUGGESTIONS_CATEGORY_LIST_TAG,
  BUNDLE_SECTIONS_SUGGESTIONS_SUB_CATEGORY_LIST_TAG,
  BUNDLE_TAG,
  BUNDLE_UNDO_REDO_HISTORY_TAG,
} from '../constants';
import { api } from '../core';
import type { RootState } from '@/store';
import { refreshBundleSectionsWithCurrentFilters } from '../bundle/getBundleSections';

export type UndoBundleResponse = null;

interface UndoBundleProps {
  bundleId: string;
}

const undoBundleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUndoBundle: builder.query<UndoBundleResponse, UndoBundleProps>({
      query: ({ bundleId }: UndoBundleProps) => ({
        url: `undo/bundle`,
        method: 'POST',
        body: {
          bundleId: bundleId,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;

          const state = getState() as RootState;
          refreshBundleSectionsWithCurrentFilters(dispatch, state);

          dispatch(
            api.util.invalidateTags([
              BUNDLE_TAG,
              BUNDLE_SECTIONS_SUGGESTIONS_CATEGORY_LIST_TAG,
              BUNDLE_SECTIONS_SUGGESTIONS_SUB_CATEGORY_LIST_TAG,
              BUNDLE_UNDO_REDO_HISTORY_TAG,
            ]),
          );
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postUndoBundle in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostUndoBundleQuery } = undoBundleApi;
